const VALID_COUNTRY_CODES = [
  'es',
  'it',
  'fr',
  'de',
  'pt',
  'gb',
  'ar',
  'cl',
  'mx',
  'br',
  'co',
  'ie',
  'us',
  'ca',
]
const LATAM_COUNTRY_CODES: Array<string> = ['mx', 'co', 'ar', 'cl']
const NEVER_NO_TOUCH_ISO_CODES = ['us', 'ca']
const ALWAYS_NO_TOUCH_ISO_CODES = ['cl']

const noTouchSeats = (isoCountryCode: string) => {
  if (LATAM_COUNTRY_CODES.includes(isoCountryCode)) return 49
  if (isoCountryCode === 'br') return 30
  if (isoCountryCode === 'de') return 10
  return 15
}

export const isNoTouchSegment = (isoCountryCode: string, seats: number) => {
  if (
    !VALID_COUNTRY_CODES.includes(isoCountryCode) ||
    ALWAYS_NO_TOUCH_ISO_CODES.includes(isoCountryCode)
  ) {
    return true
  }

  if (NEVER_NO_TOUCH_ISO_CODES.includes(isoCountryCode)) {
    return false
  }

  return seats <= noTouchSeats(isoCountryCode)
}
